import React from 'react'
import { FormControl, FormGroup, InputLabel, MenuItem, Select } from '@mui/material'

const Display = ({ form, change }) => {
  return (
    <>
      <FormGroup className="form-group" row={true}>
        <FormControl variant="standard">
          <InputLabel id="team">テーマ</InputLabel>
          <Select labelId="theme"
                  className="theme wide-select"
                  MenuProps={{ className: 'theme-menu' }}
                  value={form.display.theme}
                  onChange={change.value(value => ({ display: { theme: { $set: value } } }))}>
            <MenuItem value="default" className="default">デフォルト</MenuItem>
            <MenuItem value="dark" className="dark">ダーク</MenuItem>
          </Select>
        </FormControl>
      </FormGroup>
    </>
  )
}

export default Display
